import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "location",
    "locationGroup",
    "customLocationsSection",
    "offDescription",
    "pendingActivationDescription",
    "globalDescription",
    "customLocationsDescription",
  ];

  connect() {
    // Set initial state of group checkboxes based on their individual location checkboxes
    this.locationGroupTargets.forEach((groupCheckbox) => {
      const locationGroupId = groupCheckbox.dataset.locationGroupId;
      const locationGroupLocations = this.locationTargets.filter((locationCheckbox) => {
        return locationCheckbox.dataset.parentLocationGroupId === locationGroupId;
      });

      // Check if all locations in this group are checked
      const allLocationsChecked = locationGroupLocations.every((locationCheckbox) => {
        return locationCheckbox.checked;
      });

      // Set the group checkbox to checked if all its locations are checked
      groupCheckbox.checked = allLocationsChecked;
    });
  }

  toggleStatus(event) {
    const mode = event.currentTarget.value;
    this.customLocationsSectionTarget.classList.toggle("hidden", mode !== "custom_locations");
    this.offDescriptionTarget.classList.toggle("hidden", mode !== "off");
    this.pendingActivationDescriptionTarget.classList.toggle(
      "hidden",
      mode !== "pending_activation"
    );
    this.globalDescriptionTarget.classList.toggle("hidden", mode !== "global");
    this.customLocationsDescriptionTarget.classList.toggle("hidden", mode !== "custom_locations");
  }

  toggleLocationGroup(event) {
    const locationGroupId = event.target.dataset.locationGroupId;
    const isChecked = event.target.checked;

    const locationGroupLocations = this.locationTargets.filter((locationCheckbox) => {
      return locationCheckbox.dataset.parentLocationGroupId === locationGroupId;
    });

    locationGroupLocations.forEach((locationCheckbox) => {
      locationCheckbox.checked = isChecked;
    });
  }

  toggleLocation(event) {
    const locationGroupId = event.target.dataset.parentLocationGroupId;
    const isChecked = event.target.checked;

    // Get the group checkbox
    const groupCheckbox = this.locationGroupTargets.find((groupCheckbox) => {
      return groupCheckbox.dataset.locationGroupId === locationGroupId;
    });

    if (groupCheckbox) {
      // If location was toggled off and group was enabled, turn off the group
      if (!isChecked && groupCheckbox.checked) {
        groupCheckbox.checked = false;
      } else {
        // Otherwise, check if all locations in this group are now checked
        const locationGroupLocations = this.locationTargets.filter((locationCheckbox) => {
          return locationCheckbox.dataset.parentLocationGroupId === locationGroupId;
        });

        const allLocationsChecked = locationGroupLocations.every((locationCheckbox) => {
          return locationCheckbox.checked;
        });

        groupCheckbox.checked = allLocationsChecked;
      }
    }
  }
}
